/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

export default function SingleTestimonial({ data }) {
  if (!data) return null;
  return (
    <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
      <div className="text-center mb-8">
        <span className="section-eyebrow">Client Voice</span>
        <h2 className="text-3xl lg:text-4xl font-bold text-white mt-4">
          What our <span className="neon-text">clients</span> say
        </h2>
      </div>
      <div className="single-testimonial">
        <p className="testimonial-quote">{data.testimoni}</p>
        <div className="testimonial-attrib">{data.name}</div>
        <div className="testimonial-attrib-company">{data.company}</div>
      </div>
    </section>
  );
}
